<template>
  <section class="omx-card" :class="['omx-card--' + density]">
    <header class="omx-card__head" v-if="title || $slots.title || $slots['head-actions']">
      <div class="omx-card__title-wrap">
        <h3 class="omx-card__title">
          <slot name="title">{{ title }}</slot>
        </h3>
        <p v-if="description" class="omx-card__desc">{{ description }}</p>
      </div>
      <div class="omx-card__head-actions" v-if="$slots['head-actions']">
        <slot name="head-actions" />
      </div>
    </header>
    <div class="omx-card__body">
      <slot />
    </div>
    <footer class="omx-card__foot" v-if="$slots.foot">
      <slot name="foot" />
    </footer>
  </section>
</template>

<script>
/**
 * OmxCard — generic section card for detail pages and dashboards.
 *
 *   <OmxCard :title="$t('project.profitability')" description="last 14 days">
 *     <template #head-actions>
 *       <b-dropdown ...>...</b-dropdown>
 *     </template>
 *     ...chart...
 *   </OmxCard>
 *
 * Density: 'comfortable' (default, 18px), 'compact' (12px), 'roomy' (24px).
 */
export default {
  name: "OmxCard",
  props: {
    title:       { type: String, default: null },
    description: { type: String, default: null },
    density:     { type: String, default: "comfortable" }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.omx-card {
  background: $omx-surface;
  border: 1px solid $omx-ink-100;
  border-radius: $omx-radius-lg;
  display: flex;
  flex-direction: column;

  &--compact     { padding: 12px; }
  &--comfortable { padding: 18px; }
  &--roomy       { padding: 24px; }
}

.omx-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.omx-card__title-wrap { min-width: 0; }
.omx-card__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -.005em;
  color: $omx-ink-900;
}
.omx-card__desc {
  margin: 2px 0 0;
  font-size: 12px;
  color: $omx-ink-500;
}
.omx-card__head-actions {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-shrink: 0;
}

.omx-card__body { min-width: 0; }

.omx-card__foot {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid $omx-ink-100;
  font-size: 12px;
  color: $omx-ink-500;
}
</style>
